const OrSeparator = () => {
  const separatorClassName = 'w-full border-grey-hide';

  return (
    <div className="flex w-full items-center py-4 text-white">
      <hr className={separatorClassName} />
      <span className="px-4 text-grey-hide">Or</span>
      <hr className={separatorClassName} />
    </div>
  );
};

export default OrSeparator;
